// extracted by mini-css-extract-plugin
export default {"ExampleCards":"ExampleCards_ExampleCards__ym2mJ","Card":"ExampleCards_Card__eoq5w","CardText":"ExampleCards_CardText__AWSqO"};